import './styles.scss'
import React from 'react'

import { Button } from 'components/Form'

const SimpleBanner = ({ className, title, subtitle, buttonText, buttonAction, isSubmitting, isFloating }) => (
  <div className={`av-banner ${className ? className : ''} ${isFloating ? 'av-banner--floating' : ''}`}>
    <div className='av-banner__content'>
      <p className='av-banner__title'>{title}</p>
      <p className='av-banner__subtitle'>{subtitle}</p>
    </div>
    <Button
      secondary
      value={buttonText}
      onClick={buttonAction}
      isSubmitting={isSubmitting}
    />
  </div>
)

export default SimpleBanner
